const hr = {
  pleaseEnterUsername: "Molimo unesite korisničko ime",
  cannotFriendYourself: "Ne možete poslati zahtjev za prijateljstvo sami sebi.",
  friendRequestSent: "Zahtjev za prijateljstvo je poslan!",
  failedToSendRequest: "Slanje zahtjeva nije uspjelo",
  linkCopied: "Poveznica je kopirana u međuspremnik!",
  backToInvites: "Natrag na pozivnice",
  sendFriendRequestByUsername: "Pošalji zahtjev za prijateljstvo pomoću korisničkog imena",
  enterUsername: "Unesite korisničko ime",
  send: "Pošalji",
  yourInviteQrCode: "Vaš QR kod pozivnice",
  inviteLink: "Poveznica pozivnice",
  scanQrOrUseLink: "Skenirajte ovaj QR kod ili koristite ovu poveznicu za slanje zahtjeva za prijateljstvo",
  copyInviteLink: "Kopiraj poveznicu pozivnice",
  goToItem: "Idi na stavku",
  verificationEmailSent: "E-mail za potvrdu je poslan! Provjerite svoju pristiglu poštu.",
  verificationEmailFailed: "Slanje e-maila za potvrdu nije uspjelo. Pokušajte ponovno.",
  verifyYourEmail: "Potvrdite svoju e-mail adresu",
  verifyEmailInstructions: "Molimo potvrdite svoju e-mail adresu kako biste pristupili svom računu. Provjerite svoju pristiglu poštu za poveznicu za potvrdu.",
  sending: "Slanje...",
  resendVerificationEmail: "Ponovno pošalji e-mail za potvrdu",
  login: "Prijava",
  register: "Registracija",
  home: "Početna",
  calendar: "Kalendar",
  friends: "Prijatelji",
  profile: "Profil",
  logout: "Odjava",
  loading: "Učitavanje...",
  language: "Jezik",
  calendarSelectPlaceSuggestion: "Molimo odaberite mjesto iz prijedloga kako bi se pridružile koordinate.",
  calendarSelectDateAndTime: "Molimo odaberite datum i vrijeme.",
  calendarPositiveDuration: "Molimo unesite pozitivno trajanje.",
  calendarFutureDateRequired: "Datum i vrijeme događaja moraju biti u budućnosti.",
  calendarCreateEventFailed: "Stvaranje događaja nije uspjelo. Pokušajte ponovno.",
  cancel: "Odustani",
  createNewEvent: "Stvori novi događaj",
  week: "Tjedan",
  month: "Mjesec",
  eventTitle: "Naslov",
  date: "Datum",
  time: "Vrijeme",
  duration: "Trajanje",
  endsAt: "Završava u",
  place: "Mjesto",
  searchForPlace: "Pretraži mjesto",
  placeSearchTip: "Savjet: počnite tipkati i odaberite rezultat za dodavanje koordinata.",
  description: "Opis",
  createEvent: "Stvori događaj",
  today: "Danas",
  previousMonth: "Prethodni mjesec",
  nextMonth: "Sljedeći mjesec",
  previous: "Prethodni",
  next: "Sljedeći",
  mondayShort: "Pon",
  tuesdayShort: "Uto",
  wednesdayShort: "Sri",
  thursdayShort: "Čet",
  fridayShort: "Pet",
  saturdayShort: "Sub",
  sundayShort: "Ned",
  more: "više",
  mustRespondWillBeforeReposting: "Morate odgovoriti \"Dolazim\" prije ponovne objave",
  event: "Događaj",
  backToCalendar: "Natrag na kalendar",
  addToGoogleCalendar: "Dodaj u Google Kalendar",
  when: "Kada",
  where: "Gdje",
  openLocationInGoogleMaps: "Otvori lokaciju u Google Kartama",
  hosts: "Domaćini",
  yourResponse: "Vaš odgovor",
  currentResponse: "Trenutni odgovor",
  response_will: "Dolazim",
  response_might: "Možda dolazim",
  response_wont: "Ne dolazim",
  willRunIntoYou: "Navratit ću",
  mightDropBy: "Možda navratim",
  wontCome: "Neću doći",
  repostToMyFriends: "Ponovno podijeli prijateljima",
  responses: "Odgovori",
  willAttend: "Dolazi",
  reposted: "Ponovno podijeljeno",
  mightAttend: "Možda dolazi",
  cancelEvent: "Otkaži događaj",
  cancellationEmailNoticeBefore: "Sudionici koji su potvrdili dolazak",
  cancellationEmailNoticeAfter: "bit će obaviješteni e-mailom o otkazivanju.",
  optionalCancellationMessage: "Neobavezna poruka sudionicima (maksimalno 1000 znakova)",
  confirmCancelEvent: "Potvrdi otkazivanje događaja",
  clear: "Očisti",
  confirmCancellation: "Potvrdi otkazivanje",
  confirmCancellationMessage: "Jeste li sigurni da želite otkazati ovaj događaj? Potvrđeni sudionici bit će obaviješteni, a događaj uklonjen.",
  eventCancelledNotified: "Događaj je otkazan. Obaviješteno",
  attendees: "sudionika",
  failedToCancelEvent: "Otkazivanje događaja nije uspjelo",
  back: "Natrag",
  cancelled: "Otkazano",
  ok: "U redu",
  forgotPassword: "Zaboravljena lozinka",
  email: "E-mail",
  passwordResetLinkSent: "Ako račun postoji, poslana je poveznica za resetiranje lozinke.",
  passwordResetRequestFailed: "Zahtjev za resetiranje lozinke nije uspio.",
  sendResetLink: "Pošalji poveznicu za resetiranje",
  addFriend: "Dodaj prijatelja",
  incomingRequests: "Dolazni zahtjevi",
  accept: "Prihvati",
  deny: "Odbij",
  myFriends: "Moji prijatelji",
  noFriendsYet: "Još nemate prijatelja. Počnite ih dodavati!",
  seeProfile: "Pogledaj profil",
  noEventsToRespondTo: "Nema događaja za odgovor",
  allCaughtUp: "Sve je pregledano. Provjerite kasnije za nove događaje svojih prijatelja.",
  events: "Događaji",
  unknown: "Nepoznato",
  noDescriptionProvided: "Opis nije dostavljen.",
  will: "Da",
  maybe: "Možda",
  wont: "Ne",
  userNotFound: "Korisnik nije pronađen",
  friendRequestSentSuccessfully: "Zahtjev za prijateljstvo uspješno poslan!",
  friendInvitation: "Pozivnica za prijateljstvo",
  sendFriendRequest: "Pošalji zahtjev za prijateljstvo",
  loginToSendFriendRequest: "Molimo prijavite se za slanje zahtjeva za prijateljstvo",
  chooseLanguage: "Odaberite jezik",
  invalidCredentials: "Neispravni podaci za prijavu. Pokušajte ponovno.",
  username: "Korisničko ime",
  password: "Lozinka",
  forgotPasswordQuestion: "Zaboravili ste lozinku?",
  dontHaveAccount: "Nemate račun?",
  registerHere: "Registrirajte se ovdje",
  invalidProfilePhotoType: "Neispravna vrsta datoteke. Prenesite JPEG, PNG, GIF ili WebP sliku.",
  invalidFileExtension: "Neispravan nastavak datoteke",
  allowedExtensions: "Dopušteno",
  fileTooLarge: "Datoteka je prevelika",
  maximumFileSize: "Maksimalno",
  profilePhotoRemoved: "Profilna fotografija je uklonjena.",
  failedToRemoveProfilePhoto: "Uklanjanje profilne fotografije nije uspjelo",
  profileUpdatedSuccessfully: "Profil je uspješno ažuriran!",
  failedToUpdateProfile: "Ažuriranje profila nije uspjelo",
  privateEmailExplanation: "Samo vi možete vidjeti svoju e-mail adresu kako biste izbjegli neželjene poruke izvan platforme",
  yourEmailIsPrivate: "Vaša e-mail adresa je privatna.",
  profilePhoto: "Profilna fotografija",
  removePhoto: "Ukloni fotografiju",
  firstName: "Ime",
  lastName: "Prezime",
  tellPeopleAboutYourself: "Recite nešto o sebi",
  whereToContactMe: "Kako me kontaktirati",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "Spremi",
  notSet: "Nije postavljeno",
  editProfile: "Uredi profil",
  imageToCrop: "Slika za obrezivanje",
  zoom: "Zumiranje",
  usePhoto: "Koristi fotografiju",
  name: "Ime",
  whereToContact: "Kontakt",
  removeFriendship: "Ukloni prijateljstvo",
  confirmRemoveFriend: "Potvrdi uklanjanje prijatelja",
  confirmRemoveFriendBefore: "Jeste li sigurni da želite ukloniti",
  confirmRemoveFriendAfter: "sa svojeg popisa prijatelja?",
  friendRemoved: "Prijatelj je uklonjen.",
  failedToRemoveFriend: "Uklanjanje prijatelja nije uspjelo.",
  confirmRemove: "Potvrdi uklanjanje",
  error: "Greška",
  removed: "Uklonjeno",
  passwordsDoNotMatch: "Lozinke se ne podudaraju",
  registrationFailed: "Registracija nije uspjela. Pokušajte ponovno.",
  confirmPassword: "Potvrdi lozinku",
  alreadyHaveAccount: "Već imate račun?",
  loginHere: "Prijavite se ovdje",
  passwordResetSuccessfully: "Lozinka je uspješno resetirana.",
  failedToResetPassword: "Resetiranje lozinke nije uspjelo.",
  resetPassword: "Resetiraj lozinku",
  newPassword: "Nova lozinka",
  confirmNewPassword: "Potvrdi novu lozinku",
  setNewPassword: "Postavi novu lozinku",
  emailVerifiedSuccessfully: "E-mail adresa uspješno potvrđena!",
  emailVerificationFailed: "Potvrda nije uspjela. Poveznica je možda neispravna ili je istekla.",
  verifying: "Potvrđivanje...",
  verified: "Potvrđeno!",
  redirectingToHome: "Preusmjeravanje na početnu stranicu...",
  verificationFailed: "Potvrda nije uspjela",
  goToHome: "Idi na početnu stranicu",
  about: "O aplikaciji",
  aboutConceptTitle: "Koncept",
  aboutCreatorIntroduction: "Bok, ja sam Crypt0, penjač i autor aplikacije Run Into Me.",
  aboutCreatorStory: "Izradio sam ovu stranicu jer sam društven i trošio sam previše vremena na organiziranje penjanja s drugim penjačima.",
  aboutPlanningProblem: "Htio sam svima istodobno javiti kada i gdje ću se penjati, bez službenog poziva.",
  aboutDeveloperSolution: "Tada sam se sjetio da sam programer i da mogu sam napraviti rješenje.",
  aboutWelcome: "Dobro došli u Run Into Me, gdje prijateljima možete javiti za aktivnosti kojima se mogu pridružiti bez pritiska.",
  aboutCallToAction: "Ovdje objavite sljedeću aktivnost koja je zabavnija u društvu!",
  aboutTutorialTitle: "Vodič",
  aboutCalendarCreateEvent: "Na zaslonu kalendara možete i izraditi novi događaj.",
  aboutEventColorsIntroduction: "Boje označavaju status sudjelovanja:",
  aboutColorGold: "Zlatna",
  aboutColorGoldDescription: "Vi ste domaćin događaja.",
  aboutColorGreen: "Zelena",
  aboutColorGreenDescription: "Sudjelujete u događaju.",
  aboutColorOrange: "Narančasta",
  aboutColorOrangeDescription: "Odgovorili ste „možda”.",
  aboutColorBlue: "Plava",
  aboutColorBlueDescription: "Još niste odgovorili.",
  aboutColorGray: "Siva",
  aboutColorGrayDescription: "Odbili ste poziv.",
  aboutCalendarEventDetails: "Kliknite događaj za pojedinosti i odgovor.",
  aboutFriendPageTitle: "Stranica prijatelja",
  aboutFriendPageDescription: "Unesite korisničko ime ili pošaljite poveznicu / QR kod.",
  aboutHomePageTitle: "Početna stranica",
  aboutHomePageDescription: "Pregledajte događaje i javite dolazite li.",
  aboutRepostScreenTitle: "Zaslon ponovne objave",
  aboutGoogleCalendarDescription: "Dodajte događaj u Google Kalendar ovim gumbom.",
  aboutRepostDescription: "Nakon potvrde možete ponovno objaviti događaj prijateljima.",
};

export default hr;
